module.exports = __webpack_public_path__ + "static/img/web_banner003.009c6eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/web_banner003.jpg
// module id = IOA8
// module chunks = 15